import { render } from "./CreateDashboard.vue?vue&type=template&id=319301d0&scoped=true"
import script from "./CreateDashboard.vue?vue&type=script&lang=js"
export * from "./CreateDashboard.vue?vue&type=script&lang=js"

import "./CreateDashboard.vue?vue&type=style&index=0&id=319301d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319301d0"]])

export default __exports__